export const fullDateLocation = 'ev-full-date-location';
export const listImagePlaceholder = 'ev-list-image-placeholder';
export const listImage = 'ev-list-image';
export const listTitle = 'list-title';
export const listItem = 'event-list-item';
export const cards = 'events-cards';
export const card = 'events-card';
export const image = 'image';
export const eventTitle = 'event-title';
export const singleDate = 'date-container';
export const singleImage = 'ev-image';
export const singleLocation = 'location-container';
export const rsvpButton = 'ev-rsvp-button';
export const members = 'members-avatars';
export const loadMoreButton = 'load-more-button';
export const loadMoreButtonContainer = 'load-more-button-container';
export const EVENTS_CARD = 'events-card';
//# sourceMappingURL=widget.js.map